"use client";

import { createContext, useContext } from "react";

type Site = { contactEmail: string; builderEnabled: boolean };

// Hands runtime settings from the server layout to client components, which
// cannot read server env vars themselves.
const SiteContext = createContext<Site>({ contactEmail: "", builderEnabled: false });

export function SiteProvider({ children, ...site }: Site & { children: React.ReactNode }) {
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useContactEmail = () => useContext(SiteContext).contactEmail;

export const useBuilderEnabled = () => useContext(SiteContext).builderEnabled;
